import React, { Component } from 'react';
import { translate } from 'react-i18next';

class ProsaPaymentSuccess extends Component {
  render() {
    const { t } = this.props;
    var paymentPending = this.props.successButPending;
    return(
      <div>
        {!paymentPending && <h2 className="page-header"> PAGO EXITOSO</h2>}
        {paymentPending && <h2 className="page-header"> PAGO PENDIENTE</h2>}
        <div>
       {t('dashboard.invoice_payment.details')}
       </div>
      </div>  
    );
  }
}

export default translate('common')(ProsaPaymentSuccess);



// WEBPACK FOOTER //
// ./src/dashboard/invoices/payment/ProsaPaymentSuccess.js